import React, { Component } from 'react';
// import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SnackBar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import { getErrorMessage } from '../../../../utils/validation/errorMessages';

type Props = {
  errorMessage: string,
  handleCloseDialog: () => void,
  openDialog: boolean,
};

export class ErrorDialog extends Component {
  props: Props;
  state: {
    actionButtons: Array<FlatButton>,
  };

  state = {
    actionButtons: [
      <FlatButton
        key="OK"
        label="OK"
        primary
        keyboardFocused
        onClick={this.props.handleCloseDialog}
      />,
    ],
  };

  render() {
    const { errorMessage, handleCloseDialog, openDialog } = this.props;
    const useDialog = errorMessage === getErrorMessage('STRIPE_ERROR');
    const { actionButtons } = this.state;
    return useDialog ? (
      <Dialog
        actions={actionButtons}
        open={openDialog}
        onClose={handleCloseDialog}
      >
        {' '}
        {errorMessage}{' '}
      </Dialog>
    ) : (
      <SnackBar
        message={errorMessage}
        autoHideDuration={10000}
        open={openDialog}
        onRequestClose={handleCloseDialog}
        style={{ zIndex: '4000' }}
        bodyStyle={{
          backgroundColor: '#de5949',
          textAlign: 'center',
          zIndex: '4000',
        }}
      />
    );
  }
}

export default ErrorDialog;
